import React from 'react';
import { Navbar, Container } from 'react-bootstrap';
import { FaBookOpen, FaBox, FaShoppingCart } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const PageHeader = ({ totalBooks, totalWeight, totalPrice }) => {
    const navigate = useNavigate();
  return (
    <Navbar bg="primary" variant="dark" className="mb-3">
      <Container className="d-flex justify-content-around align-items-center">
        <div 
        className="d-flex align-items-center text-white" 
        onClick={() => navigate('/cart')} 
        style={{ cursor: 'pointer' }}
        >
          <FaBookOpen className="me-2" />
          <span>{totalBooks} boeken</span>
        </div>

        <span className="text-white">|</span>

        <div 
        className="d-flex align-items-center text-white" 
        onClick={() => navigate('/cart')} 
        style={{ cursor: 'pointer' }}
        >
          <FaBox className="me-2" />
          <span>{totalWeight} kg</span>
        </div>

        <span className="text-white">|</span>

        <div 
        className="d-flex align-items-center text-white" 
        onClick={() => navigate('/cart')} 
        style={{ cursor: 'pointer' }}
        >
          <FaShoppingCart className="me-2" />
          <span>€ {totalPrice}</span>
        </div>
      </Container>
    </Navbar>
  );
};

export default PageHeader;
